Ext.ns('mx.app.widget');

mx.app.widget.WindowForm = Ext.extend(Ext.Window, {
    modal: true,
    layout: 'fit',
    constrain: true,
    resizable: false,
    border: false,
    width: 600,
    buttonAlign: 'right',
    bodyStyle: 'padding: 5px;',
    editable: false,
    hasCloseButton: false,
    readOnly: null,
    formClassConfig: {},
    labels: {
        ok: 'OK',
        cancel: 'Cancel',
        close: 'Close',
    },
    addButtons: function() {
        this.addEvents('ok', 'cancel');

        this.okButton = this.addButton({
            name: 'ok_window',
            text: window.MXBT ? MXBT.loc('mx.app.widget.WindowForm', 'ok') : 'OK',
            handler: function(btn, e) {
                if (this.form.getForm().isValid()) {
                    if (this.fireEvent('ok', btn, e) !== false) {
                        this.destroy();
                    }
                } else {
                    Ext.Msg.show({
                        title: 'Warning',
                        msg: 'Some fields are not filled out correctly',
                        icon: Ext.Msg.WARNING,
                        buttons: Ext.Msg.OK,
                    });
                }
            },
            scope: this,
        });

        this.cancelButton = this.addButton({
            name: 'cancel_window',
            text: window.MXBT ? MXBT.loc('mx.app.widget.WindowForm', 'cancel') : 'cancel',
            handler: function(btn, e) {
                if (this.fireEvent('cancel', btn, e) !== false) {
                    this.destroy();
                }
            },
            scope: this,
        });
    },
    addCloseButton: function() {
        this.addEvents('close');

        this.closeButton = this.addButton({
            name: 'close_window',
            text: window.MXBT ? MXBT.loc('mx.app.widget.WindowForm', 'close') : 'close',
            handler: function(btn, e) {
                if (this.fireEvent('close', btn, e) !== false) {
                    this.destroy();
                }
            },
            scope: this,
        });
    },
    initComponent: function() {
        mx.app.widget.WindowForm.superclass.initComponent.apply(this, arguments);

        var readOnly = this.readOnly != null ? this.readOnly : !this.editable;

        var wrapper = new Ext.Panel({
            // we need wrapper panel around our form to work around IE7 bug with autoscrolling
            autoHeight: this.autoScroll ? false : true,
            border: false,
            autoScroll: this.autoScroll,
        });

        if (!this.form) {
            this.form = new this.formClass(
                Ext.apply({trackResetOnLoad: true, scope: this, readOnly: readOnly}, this.formClassConfig)
            );
        }

        wrapper.add(this.form);
        this.add(wrapper);

        if (this.editable) {
            this.addButtons();
        }

        if (this.hasCloseButton) {
            this.addCloseButton();
        }
    },
});
